import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { config } from './config';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.applicationInsights.instrumentationKey,
    extensions: [],
    extensionConfig: {},
  },
});
if (import.meta.env.PROD) {
  appInsights.loadAppInsights();
}
export { appInsights };
